import React,{useState,useEffect} from 'react'
import { useParams } from 'react-router-dom';
import displayPageServices from '../displayPageServices';
import AnnounceToken from '../components/AnnounceToken';
import DisplayCurrentToken from '../components/DisplayCurrentToken';
import { useMqtt } from '../../../context/MqttContext';

function AppointmentDisplayPage() {
    const {displayType} = useParams();

    const {newMessage} = useMqtt();
    

    const [displayList,setDisplayList] = useState(null);
    const [displayInfo,setDisplayInfo] = useState(null);

    const getCheckinDisplayList = () => {
        if(displayType ==='waiting-list' || displayType ==='current-token' ){
            displayPageServices.getAppointmentDisplayList().then(res=>{
                setDisplayList(res.data);
            }).catch(error=>{
            })
        }
    }

    const getCheckinDisplayInfo = () => {
        displayPageServices.getCheckinDisplayInfo().then(res=>{
            setDisplayInfo(res.data);
        }).catch(error=>{
        })
    }
    useEffect(()=>{
        getCheckinDisplayList();
        getCheckinDisplayInfo();
    },[])


    const [announceTokenId,setAnnounceTokenId] = useState(0);

    useEffect(()=>{
        if(newMessage!== null){
            const {event,data} = newMessage;
            if(event === "announcement"){
                setAnnounceTokenId(data)
            }
            getCheckinDisplayList();
        }
        console.log(newMessage);
    },[newMessage])


    const [midSpeech,setMidSpeech] = useState("");
    const [postSpeech,setPostSpeech] = useState("");
    const getSpeechConfig = () =>{
        console.log("getting Speach config")
        let _midSpeech = localStorage.getItem("midSpeech");
        let _postSpeech = localStorage.getItem("postSpeech");
        localStorage.setItem("midSpeech",_midSpeech||"")
        localStorage.setItem("postSpeech",_postSpeech||"")
        setMidSpeech(_midSpeech||"")
        setPostSpeech(_postSpeech||" से संपर्क करे")
    }
    useEffect(()=>{
        getSpeechConfig();
    },[])

    return (
        <>
            { (displayType ==='waiting-list' || displayType ==='current-token' || displayType==='multiple-display') &&
                <AnnounceToken announceToken={announceTokenId} midSpeech={midSpeech} postSpeech={postSpeech} />
            }

            
            {displayType==='current-token' && displayInfo && displayList && <DisplayCurrentToken displayList={displayList}  displayInfo={displayInfo} /> }
        </>
    )
}

export default AppointmentDisplayPage